window.ondragstart = function () { return false; }

document.addEventListener("DOMContentLoaded", function () {

    document.addEventListener("click", function (event) {
        const link = event.target.closest(".set .payment_set");
        if (!link) return; // only run if <a> inside .set was clicked

        var $this = $(link); // now it's the correct <a>
        var $content = $this.next(".content");
        var $iconContainer = $this.find(".circle-chevron");

        if ($content.is(":visible")) {
            $content.slideUp(200);
            $iconContainer.removeClass("expanded").html(`
            <svg role="presentation" focusable="false" width="8" height="6" class="icon icon-chevron-bottom-small" viewBox="0 0 8 6">
                <path d="m1 1.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
            `);
        } else {
            $(".content").slideUp(200);
            $(".set a .circle-chevron").removeClass("expanded").html(`
            <svg role="presentation" focusable="false" width="8" height="6" class="icon icon-chevron-bottom-small" viewBox="0 0 8 6">
                <path d="m1 1.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
            `);

            $content.slideDown(200);
            $iconContainer.addClass("expanded").html(`
            <svg role="presentation" focusable="false" width="8" height="6" class="icon icon-chevron-bottom-small" viewBox="0 0 8 6">
                <path d="m1 3 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
            `);
        }
    });


    // Ensure script runs after the DOM loads
    function setupUpsellButtons() {
        document.querySelectorAll(".add-upsell").forEach(button => {
            button.addEventListener("click", function () {
                let variantId = this.getAttribute("data-id");

                if (!variantId) {
                    console.error("Error: Variant ID not found");
                    return;
                }

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: variantId, quantity: 1 })
                })
                    .then(response => {
                        if (!response.ok) throw new Error("Network response was not ok");
                        return response.json();
                    })
                    .then(data => {
                        console.log("Added to cart:", data);

                        // Update cart drawer (if using AJAX cart)
                        if (window.Shopify && Shopify.onItemAdded) {
                            Shopify.onItemAdded(data);
                        } else {
                            location.reload(); // Reload if no AJAX cart is present
                        }
                    })
                    .catch(error => console.error("Error adding product:", error));
            });
        });
    }

    setupUpsellButtons(); // Run on page load
});


$(document).ready(function () {
    $('#view-more-upsell').click(function () {
        $('.hidden-upsell').slideDown();
        $(this).hide();
        $('#view-less-upsell').show();
    });

    $('#view-less-upsell').click(function () {
        $('.hidden-upsell').slideUp();
        $(this).hide();
        $('#view-more-upsell').show();
        $('html, body').animate({
            scrollTop: $('#upsell-products').offset().top
        }, 300);
    });
});


// VAT Auto-fill Logic (Global Handler)
(function () {
    function detectCountryCode() {
        let countryCode = (window.SHOPIFY_COUNTRY_CODE || '').toString().trim().toUpperCase();

        // Primary source on Shopify storefronts
        if (!countryCode && window.Shopify && window.Shopify.country) {
            countryCode = String(window.Shopify.country).trim().toUpperCase();
        }

        // Secondary source from locale selector or html lang
        if (!countryCode) {
            const htmlLang = (document.documentElement.lang || '').trim().toLowerCase();
            const localeMap = {
                en: 'GB',
                de: 'DE',
                fr: 'FR',
                it: 'IT',
                es: 'ES',
                pl: 'PL',
                nl: 'NL',
                pt: 'PT',
                cs: 'CZ',
                ro: 'RO',
                uk: 'UA',
                el: 'GR'
            };
            countryCode = localeMap[htmlLang] || '';
        }

        // Fallback: try locale prefix in URL, e.g. /it, /de, /fr
        if (!countryCode) {
            const pathUrl = window.location.pathname.split('/');
            if (pathUrl.length > 1 && pathUrl[1]) {
                countryCode = pathUrl[1].split('-').slice(-1)[0].toUpperCase();
            }
        }

        // Keep only two-letter prefixes
        if (!/^[A-Z]{2}$/.test(countryCode)) return '';
        return countryCode;
    }

    function tryPrefillVatPrefix(inputEl) {
        if (!inputEl) return;

        // For private purchase we intentionally do not prefill.
        if ($('#vat-skip-checkbox').is(':checked')) return;

        if ((inputEl.value || '').trim().length > 0) return;

        const countryCode = detectCountryCode();
        if (!countryCode) return;

        inputEl.value = countryCode;
        inputEl.dispatchEvent(new Event('input', { bubbles: true }));
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    document.addEventListener('focus', function (e) {
        if (e.target && e.target.id === 'user-vat') {
            const rawInput = e.target;

            // Delay bypasses app's potential clear-on-focus behavior.
            setTimeout(function () {
                tryPrefillVatPrefix(rawInput);
            }, 500);
        }
    }, true); // capture phase, input can be mounted by app block later

    // Also prefill immediately when user switches from private to business mode.
    document.addEventListener('change', function (e) {
        if (e.target && e.target.id === 'vat-skip-checkbox' && !e.target.checked) {
            setTimeout(function () {
                tryPrefillVatPrefix(document.getElementById('user-vat'));
            }, 50);
        }
    }, true);
})();